module.exports = __webpack_public_path__ + "static/media/Stephen.0c6f6b84.png";